import { samplePath } from "./math/samplePath";
import { penguin, penguinRestBodyPath, penguinRightFlipperPath } from "./shapes/penguin";

// Use exactly the same sampled outline and normalization as the Fourier model.
const samples = samplePath(penguin, 1024);
const center = samples.reduce(
  (sum, point) => ({ x: sum.x + point.x / samples.length, y: sum.y + point.y / samples.length }),
  { x: 0, y: 0 },
);
const extent = Math.max(
  Math.max(...samples.map((point) => point.x)) - Math.min(...samples.map((point) => point.x)),
  Math.max(...samples.map((point) => point.y)) - Math.min(...samples.map((point) => point.y)),
);

// Morph the finished flipper from its traced rest pose into a broad shoulder
// and a rounded, tapered tip. Match SVG commands so the lift stays continuous.
const restFlipperCoordinates = penguinRightFlipperPath.match(/-?\d+(?:\.\d+)?/g)!.map(Number);
const wavingFlipperCoordinates = [
  946, 472, 1005, 430, 1105, 335, 1145, 390,
  1180, 440, 1088, 610, 992, 655, 962, 675, 921, 619, 905, 560,
  896, 540, 901, 506, 918, 485, 926, 477, 936, 473, 946, 472,
];

export const PenguinArtwork = ({ wingAngle = 0 }: { wingAngle?: number }) => {
  // The original outline is "from"; the raised reference silhouette is "to".
  // Two flaps move between 82% and 100% of that pose without stretching it.
  const waveLift = Math.min(1, Math.abs(wingAngle) / 100);
  let coordinateIndex = 0;
  const flipperPath = penguinRightFlipperPath.replace(/-?\d+(?:\.\d+)?/g, () => {
    const index = coordinateIndex++;
    return String(restFlipperCoordinates[index] +
      (wavingFlipperCoordinates[index] - restFlipperCoordinates[index]) * waveLift);
  });
  return (
  <g transform={`scale(${2 / extent}) translate(${-center.x} ${-center.y})`}>
    <path
      d={flipperPath}
      fill="#101820"
      stroke="#101820"
      strokeWidth={1}
      strokeLinejoin="round"
    />
    <path d={penguinRestBodyPath} fill="#101820" />
    <path
      d="M 626 303 C 596 234 549 193 489 193 C 413 193 351 260 350 369 C 347 431 367 477 409 514 C 334 584 304 713 310 833 C 320 1006 438 1105 627 1106 C 813 1105 932 1004 944 839 C 951 715 923 580 844 514 C 883 480 904 429 904 365 C 902 256 839 193 766 193 C 704 193 655 235 626 303 Z"
      fill="#FFFFFF"
    />
    <circle cx="474" cy="357" r="46" fill="#101820" />
    <circle cx="779" cy="357" r="46" fill="#101820" />
    <circle cx="488" cy="338" r="14" fill="#FFFFFF" />
    <circle cx="766" cy="338" r="14" fill="#FFFFFF" />
    <path
      d="M 565 406 C 590 378 660 369 688 403 C 703 422 648 475 627 470 C 606 469 552 422 565 406 Z"
      fill="#101820"
    />
  </g>
  );
};


